module.exports = __webpack_public_path__ + "img/dt.0b7153ab.png";